/**
 * Will look for element #DigitalIdentityHubHost
 * And try to fill it with the widget screens
 * If a div with the same name as a screen already exists on the page, the screen won't be inserted again
 */
const setHtml = html => {
  const payload = document.createElement("div");
  payload.innerHTML = html;

  const host = document.getElementById("DigitalIdentityHubHost");

  for (let i = payload.children.length - 1; i >= 0; i--) {
    try {
      const screen = payload.children.item(i)!;
      const existingElement = document.getElementById(screen.id);
      if (existingElement === null && host !== null) {
        host.appendChild(screen);
      }
    } catch (ex) {
      console.log(ex);
    }
  }
};

export const LoadHTML = function() {
  return window
    .fetch(window.DigitalIdentityHub.settings.htmlEndpoint)
    .then(r => r.text())
    .then(html => {
      const tokens = window.DigitalIdentityHub.settings.htmlTokens;
      html = Object.keys(tokens).reduce((newHtml, token) => {
        const searchToken = `###${token.toUpperCase()}###`;
        newHtml = newHtml.replace(new RegExp(searchToken, "g"), tokens[token]);

        return newHtml;
      }, html);

      if (document.readyState === "complete") {
        setHtml(html);
      } else {
        return new Promise<void>(resolve => {
          document.addEventListener("readystatechange", () => {
            if (document.readyState === "complete") {
              setHtml(html);
              resolve();
            }
          });
        });
      }
    });
};
